/* ========================================
   IMPULSE THEME JS COMPATIBILITY LAYER
   For Dawn Theme - Impulse Ported Sections
   ======================================== */

(function () {
  'use strict';

  /* ----------------------------------------
     Collapsible Triggers
     ---------------------------------------- */
  function initCollapsibles() {
    var triggers = document.querySelectorAll('.collapsible-trigger, .collapsible-trigger-btn');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var content = trigger.nextElementSibling ||
          trigger.parentElement.querySelector('.collapsible-content');

        if (!content) return;

        var isOpen = content.classList.contains('is-open');

        if (isOpen) {
          content.classList.remove('is-open');
          trigger.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          content.classList.add('is-open');
          trigger.classList.add('is-active');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ----------------------------------------
     Drawer Open/Close
     ---------------------------------------- */
  function initDrawers() {
    var overlay = document.createElement('div');
    overlay.className = 'drawer-overlay';
    document.body.appendChild(overlay);

    var drawers = document.querySelectorAll('.drawer');

    function openDrawer(drawer) {
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function closeAllDrawers() {
      drawers.forEach(function (drawer) {
        drawer.classList.remove('is-open');
      });
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    overlay.addEventListener('click', closeAllDrawers);

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-drawer-open], [data-cart-toggle]');
      if (openBtn) {
        e.preventDefault();
        var drawerId = openBtn.getAttribute('data-drawer-open') || openBtn.getAttribute('data-cart-toggle');
        var drawer = document.getElementById(drawerId) || document.querySelector('.drawer');
        if (drawer) openDrawer(drawer);
      }

      var closeBtn = e.target.closest('.drawer__close, .drawer__close-button, [data-drawer-close]');
      if (closeBtn) {
        e.preventDefault();
        closeAllDrawers();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllDrawers();
      }
    });
  }

  /* ----------------------------------------
     Quantity Adjustment (js-qty)
     ---------------------------------------- */
  function initQuantityAdjustors() {
    document.addEventListener('click', function (e) {
      var adjustBtn = e.target.closest('.js-qty__adjust');
      if (!adjustBtn) return;

      var wrapper = adjustBtn.closest('.js-qty__wrapper');
      if (!wrapper) return;

      var input = wrapper.querySelector('.js-qty__num, input[type="number"]');
      if (!input) return;

      var currentVal = parseInt(input.value, 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 9999;
      var qty = currentVal;

      if (adjustBtn.classList.contains('js-qty__adjust--minus')) {
        qty = currentVal - 1;
        if (qty < min) qty = min;
      } else if (adjustBtn.classList.contains('js-qty__adjust--plus')) {
        qty = currentVal + 1;
        if (qty > max) qty = max;
      }

      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      // Dispatch custom event for Shopify theme integration
      var event = new CustomEvent('quantity:change', {
        detail: { quantity: qty, input: input },
        bubbles: true
      });
      input.dispatchEvent(event);
    });
  }

  /* ----------------------------------------
     Video Modal
     ---------------------------------------- */
  function initVideoModals() {
    document.addEventListener('click', function (e) {
      var videoTrigger = e.target.closest('[data-video-id], .video-section__link, .product-block--video a');
      if (!videoTrigger) return;

      e.preventDefault();
      var videoId = videoTrigger.getAttribute('data-video-id');
      var videoType = videoTrigger.getAttribute('data-video-type') || 'youtube';

      if (!videoId) return;

      var modal = document.querySelector('.modal--video, .modal__inner');

      // Create modal if none exists
      var videoModal = document.querySelector('.js-video-modal');
      if (!videoModal) {
        videoModal = document.createElement('div');
        videoModal.className = 'modal js-video-modal';
        videoModal.innerHTML =
          '<div class="modal__inner" style="max-width:800px;width:90%;">' +
          '<button class="modal__close js-modal-close" aria-label="Close">&times;</button>' +
          '<div class="video-wrapper" id="video-modal-wrapper"></div>' +
          '</div>';
        document.body.appendChild(videoModal);

        videoModal.querySelector('.js-modal-close').addEventListener('click', function () {
          closeVideoModal();
        });

        videoModal.addEventListener('click', function (e) {
          if (e.target === videoModal) {
            closeVideoModal();
          }
        });
      }

      var wrapper = document.getElementById('video-modal-wrapper');
      wrapper.innerHTML = '';

      var iframe = document.createElement('iframe');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');

      if (videoType === 'youtube') {
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      } else if (videoType === 'vimeo') {
        iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
      }

      wrapper.appendChild(iframe);
      videoModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    function closeVideoModal() {
      var videoModal = document.querySelector('.js-video-modal');
      if (videoModal) {
        videoModal.classList.remove('is-open');
        var wrapper = document.getElementById('video-modal-wrapper');
        if (wrapper) wrapper.innerHTML = '';
        document.body.style.overflow = '';
      }
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeVideoModal();
      }
    });
  }

  /* ----------------------------------------
     Tooltip Toggle
     ---------------------------------------- */
  function initTooltips() {
    var tooltipTriggers = document.querySelectorAll('.tool-tip-trigger');
    tooltipTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var tooltip = trigger.querySelector('.tool-tip');
        if (!tooltip) return;

        var isVisible = tooltip.classList.contains('is-visible');

        // Close all tooltips first
        document.querySelectorAll('.tool-tip.is-visible').forEach(function (t) {
          t.classList.remove('is-visible');
        });

        if (!isVisible) {
          tooltip.classList.add('is-visible');
        }
      });
    });

    // Close tooltips on outside click
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.tool-tip-trigger')) {
        document.querySelectorAll('.tool-tip.is-visible').forEach(function (t) {
          t.classList.remove('is-visible');
        });
      }
    });
  }

  /* ----------------------------------------
     Mobile Nav Toggle
     ---------------------------------------- */
  function initMobileNav() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.mobile-nav__toggle, [data-mobile-nav-toggle]');
      if (toggle) {
        e.preventDefault();
        var mobileNav = document.querySelector('.mobile-nav');
        if (mobileNav) {
          mobileNav.classList.toggle('is-open');
          document.body.classList.toggle('mobile-nav-open');
        }
        return;
      }

      // Sublist toggles
      var sublistToggle = e.target.closest('.mobile-nav__link--button');
      if (sublistToggle) {
        e.preventDefault();
        var sublist = sublistToggle.nextElementSibling;
        if (sublist && sublist.classList.contains('mobile-nav__sublist')) {
          sublist.classList.toggle('is-open');
          sublistToggle.setAttribute(
            'aria-expanded',
            sublist.classList.contains('is-open') ? 'true' : 'false'
          );
        }
        return;
      }

      // Grandchild list toggles
      var grandchildToggle = e.target.closest('.mobile-nav__faux-link');
      if (grandchildToggle) {
        e.preventDefault();
        var grandchildList = grandchildToggle.nextElementSibling;
        if (grandchildList && grandchildList.classList.contains('mobile-nav__grandchildlist')) {
          grandchildList.classList.toggle('is-open');
        }
      }
    });
  }

  /* ----------------------------------------
     Product Variant Switching (Basic)
     ---------------------------------------- */
  function initProductVariants() {
    var variantSelectors = document.querySelectorAll('.variant-wrapper, .product-single__variants');
    variantSelectors.forEach(function (wrapper) {
      var swatches = wrapper.querySelectorAll('.color-swatch, .variant__button-label');
      var productForm = wrapper.closest('form') || wrapper.closest('.product-single__meta');
      if (!productForm) return;

      var variantInput = productForm.querySelector('input[name="id"], select[name="id"]');

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();

          // Update active states
          var group = swatch.closest('.variant-input-wrap');
          if (group) {
            group.querySelectorAll('.color-swatch, .variant__button-label').forEach(function (s) {
              s.classList.remove('active', 'selected');
            });
          }
          swatch.classList.add('active', 'selected');

          // Update associated input
          var input = swatch.querySelector('input');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // Update hidden variant ID if available
          var variantId = swatch.getAttribute('data-variant-id') || (input && input.value);
          if (variantInput && variantId) {
            variantInput.value = variantId;
          }

          // Dispatch custom event
          wrapper.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: variantId },
            bubbles: true
          }));
        });
      });

      // Handle select dropdowns
      var selects = wrapper.querySelectorAll('select');
      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var selectedOption = select.options[select.selectedIndex];
          var variantId = selectedOption.getAttribute('data-variant-id') || selectedOption.value;
          if (variantInput && variantId) {
            variantInput.value = variantId;
          }

          wrapper.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: variantId },
            bubbles: true
          }));
        });
      });
    });
  }

  /* ----------------------------------------
     Tab Switching
     ---------------------------------------- */
  function initTabs() {
    document.addEventListener('click', function (e) {
      var tabLink = e.target.closest('.tab-link');
      if (!tabLink) return;

      e.preventDefault();
      var tabContainer = tabLink.closest('.tabs');
      if (!tabContainer) return;

      // Deactivate all tabs in this group
      tabContainer.querySelectorAll('.tab-link').forEach(function (link) {
        link.classList.remove('is-active', 'active');
      });
      tabContainer.querySelectorAll('.tab-content').forEach(function (content) {
        content.classList.remove('is-open');
      });

      // Activate clicked tab
      tabLink.classList.add('is-active', 'active');
      var targetId = tabLink.getAttribute('href') || tabLink.getAttribute('data-tab');
      if (targetId) {
        var targetContent = tabContainer.querySelector(targetId);
        if (targetContent) {
          targetContent.classList.add('is-open');
        }
      }
    });
  }

  /* ----------------------------------------
     Disclosure Dropdowns
     ---------------------------------------- */
  function initDisclosures() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.disclosure__toggle');
      if (toggle) {
        e.preventDefault();
        var disclosure = toggle.closest('.disclosure');
        if (!disclosure) return;

        var list = disclosure.querySelector('.disclosure-list');
        if (!list) return;

        var isOpen = list.classList.contains('is-open');

        // Close all other disclosures
        document.querySelectorAll('.disclosure-list.is-open').forEach(function (l) {
          l.classList.remove('is-open');
        });

        if (!isOpen) {
          list.classList.add('is-open');
        }
      }
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.disclosure')) {
        document.querySelectorAll('.disclosure-list.is-open').forEach(function (l) {
          l.classList.remove('is-open');
        });
      }
    });
  }

  /* ----------------------------------------
     Appear Animation Observer
     ---------------------------------------- */
  function initAppearAnimations() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.appear-animation').forEach(function (el) {
        el.classList.add('appear-animation--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('appear-animation--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.appear-animation').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------
     AOS (Animate On Scroll) - Simple
     ---------------------------------------- */
  function initAOS() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-aos]').forEach(function (el) {
        el.classList.add('aos-animate');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('aos-animate');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('[data-aos]').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------
     Newsletter Popup
     ---------------------------------------- */
  function initNewsletterPopup() {
    var popup = document.querySelector('.newsletter-popup');
    if (!popup) return;

    var closeBtn = popup.querySelector('.newsletter-popup__close, [data-close-newsletter]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.classList.remove('is-visible');
        try { sessionStorage.setItem('newsletter_popup_closed', '1'); } catch (e) {}
      });
    }

    // Show after delay if not previously closed
    try {
      if (!sessionStorage.getItem('newsletter_popup_closed')) {
        setTimeout(function () {
          popup.classList.add('is-visible');
        }, 5000);
      }
    } catch (e) {
      setTimeout(function () {
        popup.classList.add('is-visible');
      }, 5000);
    }
  }

  /* ----------------------------------------
     Lazy Image Loading Enhancement
     ---------------------------------------- */
  function initLazyLoading() {
    // For browsers without native lazy loading
    if ('loading' in HTMLImageElement.prototype) return;

    if (!('IntersectionObserver' in window)) return;

    var images = document.querySelectorAll('[data-src], img[loading="lazy"]');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          var src = img.getAttribute('data-src');
          if (src) {
            img.src = src;
            img.classList.add('lazyloaded');
          }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });

    images.forEach(function (img) {
      observer.observe(img);
    });
  }

  /* ----------------------------------------
     Cart Link Bubble Update
     ---------------------------------------- */
  function updateCartBubble(count) {
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    bubbles.forEach(function (bubble) {
      if (count > 0) {
        bubble.classList.add('cart-link__bubble--visible');
        bubble.textContent = count;
      } else {
        bubble.classList.remove('cart-link__bubble--visible');
      }
    });
  }

  /* ----------------------------------------
     Collection Grid Filter Toggle
     ---------------------------------------- */
  function initCollectionFilters() {
    document.addEventListener('click', function (e) {
      var filterBtn = e.target.closest('.collection-grid__filter');
      if (!filterBtn) return;

      e.preventDefault();
      var filterGroup = filterBtn.closest('.collection-grid__filters');
      if (filterGroup && filterBtn.getAttribute('data-filter-type') !== 'multi') {
        filterGroup.querySelectorAll('.collection-grid__filter').forEach(function (f) {
          f.classList.remove('is-active', 'active');
        });
      }

      filterBtn.classList.toggle('is-active');
      filterBtn.classList.toggle('active');
    });
  }

  /* ----------------------------------------
     Initialize Everything
     ---------------------------------------- */
  function init() {
    initCollapsibles();
    initDrawers();
    initQuantityAdjustors();
    initVideoModals();
    initTooltips();
    initMobileNav();
    initProductVariants();
    initTabs();
    initDisclosures();
    initAppearAnimations();
    initAOS();
    initNewsletterPopup();
    initLazyLoading();
    initCollectionFilters();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose utilities for external use
  window.ImpulseCompat = {
    updateCartBubble: updateCartBubble,
    init: init
  };

})();
